import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pagina-nao-encontrada',
    templateUrl: './pagina-nao-encontrada.component.html',
    styleUrls: ['./pagina-nao-encontrada.component.scss'],
    standalone: false
})
export class PaginaNaoEncontradaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
